const plural = (count) => `${count} ${count === 1 ? "bottle" : "bottles"}`;

function recordsFor(catalogue, items, kind) {
  const countField = kind === "current" ? "currentBottleCount" : "pastBottleCount";
  return [...items.values()].filter((item) => item[countField] > 0).map((item) => {
    const record = catalogue.get(item.bottleId);
    return record ? { ...record, collection: { ...item } } : null;
  }).filter(Boolean);
}

export function createCollectionPage({ document, auth, collection, catalogue, view }) {
  const gate = document.querySelector("#collectionGate");
  const currentSection = document.querySelector("#collectionCurrentSection");
  const pastSection = document.querySelector("#collectionPastSection");
  const currentCount = document.querySelector("#collectionCurrentCount");
  const pastCount = document.querySelector("#collectionPastCount");
  let authState = { ready: false, signedIn: false };
  let collectionItems = collection.getItems();
  let unsubscribe = null;

  function render(items = collectionItems) {
    collectionItems = items;
    const currentRecords = recordsFor(catalogue, items, "current");
    const pastRecords = recordsFor(catalogue, items, "past");
    const currentBottles = [...items.values()]
      .reduce((sum, item) => sum + item.currentBottleCount, 0);
    const pastBottles = [...items.values()]
      .reduce((sum, item) => sum + item.pastBottleCount, 0);
    if (currentCount) currentCount.textContent = plural(currentBottles);
    if (pastCount) pastCount.textContent = plural(pastBottles);
    view.setSections([
      {
        key: "current",
        title: "Current Collection",
        collectionKind: "current",
        records: currentRecords,
      },
      {
        key: "past",
        title: "Past Bottles",
        collectionKind: "past",
        records: pastRecords,
      },
    ]);
  }

  function setAuthState(next) {
    authState = { ...next };
    if (!gate) return;
    gate.replaceChildren();
    if (!next.ready) {
      gate.hidden = false;
      const loading = document.createElement("p");
      loading.textContent = "Loading your account…";
      gate.append(loading);
      currentSection.hidden = true;
      pastSection.hidden = true;
      return;
    }
    if (!next.signedIn) {
      gate.hidden = false;
      const message = document.createElement("p");
      message.textContent = next.unavailable
        ? "Sign in is unavailable right now."
        : "Sign in to see and manage your collection.";
      const signIn = document.createElement("button");
      signIn.type = "button";
      signIn.textContent = next.unavailable ? "Sign in unavailable" : "Sign in or create account";
      signIn.disabled = Boolean(next.unavailable);
      signIn.addEventListener("click", () => auth.requireUser());
      gate.append(message, signIn);
      currentSection.hidden = true;
      pastSection.hidden = true;
      view.setSections([
        { key: "current", title: "Current Collection", collectionKind: "current", records: [] },
        { key: "past", title: "Past Bottles", collectionKind: "past", records: [] },
      ]);
      return;
    }
    gate.hidden = true;
    currentSection.hidden = false;
    pastSection.hidden = false;
    render();
  }

  return {
    async start() {
      unsubscribe ??= collection.subscribe((items) => {
        collectionItems = items;
        if (authState.signedIn) render(items);
      });
      setAuthState(authState);
    },
    setAuthState,
    destroy() { unsubscribe?.(); },
  };
}
